import { TIME_GRID } from 'src/config/constants.ts'
import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

export default function timeGrid ({ to, store }) {
  const queryParamsValidity = areQueryParamsValid(to)

  // If the query params are already set and valid, do nothing and move to next route
  if (queryParamsValidity.allParamsValid) return

  const getDaysToShow = (viewType) => {
    if (viewType === TIME_GRID.VIEW_TYPES.MONTH) return TIME_GRID.MAX_DAYS_TO_SHOW
    return queryParamsValidity.isDaysToShowValid ? to.query.daysToShow : defaultDaysToShow
  }

  // Otherwise set the invalid query params to default values
  const defaultDaysToShow = to.name === 'calendar-grid' ? TIME_GRID.CALENDAR.DEFAULT_DAYS_TO_SHOW : TIME_GRID.TIMETABLE.DEFAULT_DAYS_TO_SHOW
  const viewType = queryParamsValidity.isViewTypeValid ? to.query.viewType : TIME_GRID.VIEW_TYPES.WEEK
  const isScreenReaderActive = import.meta.env.IS_STORYBOOK ? false : store.state.isScreenReaderActive
  const defaultQueryParams = {
    viewType: isScreenReaderActive ? TIME_GRID.VIEW_TYPES.DAY : viewType,
    daysToShow: getDaysToShow(viewType),
    startDate: queryParamsValidity.isStartDateValid ? to.query.startDate : GlobalPrototypes.moment().startOf('isoWeek').format('YYYY-MM-DD')
  }

  return { name: to.name, params: { ...to.params }, query: { ...to.query, ...defaultQueryParams } }
}

const daysToShowAreValid = (to) => {
  const isMonthView = to.query.viewType && TIME_GRID.VIEW_TYPES[to.query.viewType.toUpperCase()] === TIME_GRID.VIEW_TYPES.MONTH
  const validWeekDays = to.query.daysToShow && !isNaN(to.query.daysToShow) && Number(to.query.daysToShow) > 0

  if (isMonthView) return Number(to.query.daysToShow) === TIME_GRID.MAX_DAYS_TO_SHOW && validWeekDays

  return Number(to.query.daysToShow) <= TIME_GRID.MAX_DAYS_TO_SHOW && validWeekDays
}

const areQueryParamsValid = (to) => {
  const isStartDateValid = to.query.startDate && GlobalPrototypes.moment(to.query.startDate).isValid()
  const isDaysToShowValid = daysToShowAreValid(to)
  const isViewTypeValid = to.query.viewType && TIME_GRID.VIEW_TYPES[to.query.viewType.toUpperCase()]

  const allParamsValid = isStartDateValid && isDaysToShowValid && isViewTypeValid

  return {
    isStartDateValid,
    isDaysToShowValid,
    isViewTypeValid,
    allParamsValid
  }
}
